<script setup lang="ts">
useHead({
  meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  link: [{ rel: 'icon', href: '/favicon.svg' }],
  link: [{ rel: 'mask-icon', href: '/favicon.svg', color: '#000000' }],
  link: [{ rel: 'apple-touch-icon', href: '/favicon-180.png' }],
  // fallback to default favicon if not found
  link: [{ rel: 'icon', href: '/favicon-180.png' }],
});
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
